export enum ComparisonOperatorEnum {
    equals,
    notEquals,
    greaterThan,
    greaterThanOrEquals,
    lessThan,
    lessThanOrEquals,
    between,
    in,
    notIn,
    contains,
    startsWith,
    endsWith,
    isNull,
    isNotNull
}
